import { Directive, ViewContainerRef, TemplateRef, Input, inject, EffectRef, runInInjectionContext, effect, OnDestroy, EnvironmentInjector } from '@angular/core';
import { FeatureFlagService } from '../services/feature-flag/feature-flag.service';

@Directive({
    selector: '[appFeatureFlag]',
    standalone: false
})
export class FeatureFlagDirective implements OnDestroy {

  private readonly viewContainer = inject(ViewContainerRef);
  private readonly templateRef = inject(TemplateRef);
  private readonly featureFlagService = inject(FeatureFlagService);
  private readonly injector = inject(EnvironmentInjector);

  private effectRef?: EffectRef;

  @Input('appFeatureFlag')
  set flagName(flag: string) {
    this.effectRef?.destroy();
    
    runInInjectionContext(this.injector, () => {
      this.effectRef = effect(() => {
        const enabled = this.featureFlagService.isFeatureFlagEnabled(flag);
        this.viewContainer.clear();
        if (enabled) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.effectRef?.destroy();
  }

}
